<div class="w-12 social-login">
    <p class="h5 m-t-10 m-t-6-s m-b m-b-0-s">{{'Or log in with your social profile' | translate}}</p>
    <div class="flex flex-top gap16">
        @for (social of socialLogin; track $index) {
        @if (social.valid) {
        <action class="button w-12 m-t-6"
                [ngClass]="'button-'+ social.serviceName"
                [class.bg-col-52]="status.busy"
                [status]="status"
                (click)="login(social.serviceName)">
            <i class="social-icon"
               [ngClass]="'login-'+ social.serviceName"></i>
        </action>
        }
        }
    </div>

    <result class="m-t-1 block"
            [status]="status"></result>
</div>